<template>
	<div class="hot-brand-swiper">
		<div class="wp">
			<h3 class="title1">{{ $t('hotBrandSwiper.title') }}</h3>
			<div class="swi-hot-brand-wrap">
				<div class="swi-hot-brand">
					<div class="swiper-wrapper">
						<div v-for="(item,index) in brandList" :key="index" class="swiper-slide">
							<router-link :to="`/brandDetail/${item.slug}`" class="icon">
								<img :src="item.img"
									:alt="`Asian food wholesaler-OCM Foods Group + ${item.brand_name} Exclusive Distribution Partner in the US, 亚洲食品批发-美国华源食品集团 + ${item.brand_name}美国独家代理`">
							</router-link>
						</div>
					</div>
				</div>
				<div class="swiper-button-next"></div>
				<div class="swiper-button-prev"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

export default {
	name: "hotBrandSwiper",
	props: ['brandList'],
	data() {
		return {
		};
	},
	mounted() {
		this.initSwiper();
	},
	methods: {
		initSwiper() {
			var swiper = new Swiper('.swi-hot-brand', {
				slidesPerView: 5,
				spaceBetween: 21,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				breakpoints: {
					2560: {
						slidesPerView: 5,
						spaceBetween: 21,

					},
					767: {
						slidesPerView: 4,
						spaceBetween: 10
					},
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">
//hot-brand-swiper
.hot-brand-swiper {
	background-color: $white2;
	padding: 40px 0;
	.wp {
		display: flex;
		align-items: center;
		.title1 {
			margin-right: 104px;
		}
		.swi-hot-brand-wrap {
			width: 0;
			flex: 1;
			position: relative;
		}
		.swi-hot-brand {
			overflow: hidden;
			.icon {
				display: block;
				padding-top: 100%;
				background-color: #fff;
				border-radius: 50%;
				position: relative;
				img {
					position: absolute;
					top: 50%;
					left: 50%;
					-webkit-transform: translate(-50%, -50%);
					-moz-transform: translate(-50%, -50%);
					-ms-transform: translate(-50%, -50%);
					transform: translate(-50%, -50%);
					width: 88px;
					height: auto;
					object-fit: contain;
				}
			}
			.icon:after {
				content: '';
				pointer-events: none;
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				border-radius: 100%;
				border: 5px solid #dddbcb;
				-webkit-transition: all 0.3s;
				-moz-transition: all 0.3s;
				-ms-transition: all 0.3s;
				-o-transition: all 0.3s;
				transition: all 0.3s;
				opacity: 0;
			}
			.icon:hover:after {
				opacity: 1;
			}
		}
		.swiper-button-next,
		.swiper-button-prev {
			width: 36px;
			height: 36px;
			background: no-repeat center center / contain;
			-webkit-transition: all 0.3s;
			-moz-transition: all 0.3s;
			-ms-transition: all 0.3s;
			-o-transition: all 0.3s;
			transition: all 0.3s;
		}
		.swiper-button-prev {
			background-image: url('~@/assets/images/swi-l.png');
			left: -80px;
		}
		.swiper-button-next {
			background-image: url('~@/assets/images/swi-r.png');
			right: -80px;
		}
		.swiper-button-prev.swiper-button-disabled,
		.swiper-button-next.swiper-button-disabled {
			opacity: 0;
		}
	}
}
@media only screen and (max-width: 959px) {
	.hot-brand-swiper .wp .swiper-button-prev,
	.hot-brand-swiper .wp .swiper-button-next {
		display: none;
	}
	.hot-brand-swiper .wp .swi-hot-brand .icon img {
		width: 60px;
	}
}
@media only screen and (max-width: 767px) {
	.hot-brand-swiper {
		padding: 20px 0;
	}
	.hot-brand-swiper .wp {
		display: block;
	}
	.hot-brand-swiper .wp .title1 {
		font-size: 20px;
		margin-right: 0;
		margin-bottom: 10px;
	}
	.hot-brand-swiper .wp .swi-hot-brand-wrap {
		width: 100%;
	}
}
</style>
